// @flow
import React from 'react';
import ConfirmationModal from '~/app/components/ConfirmationModal';
import injectSheet from 'react-jss';
import S3AssetBrowser from '~/pages/components/S3AssetBrowser';
import Row from './EditAssetRow';
import { S, DARK } from '~/app/ui/tokens';

type Image = {
  title?: ?string,
  titleColor?: ?string,
  url?: ?string,
  coverUrl?: ?string,
  socialUrl?: ?string
}

type Props = {
  onClick: (Image) => void,
  onClose: () => void,
  updateImage: (Image) => void,
  image: Image,
  classes: Object
}

const EditAssetModal = (props: Props) => {
  const {
    onClick,
    onClose,
    image,
    updateImage,
    classes: c
  } = props;
  const {
    title,
    titleColor,
    url,
    coverUrl,
    socialUrl
  } = image;
  const titleColors = ['Dark', 'Light'];
  const inputField = (
    <React.Fragment>
      <div className={c.boxTitle}>
        UPDATE ASSET
      </div>
      <Row
        title="Asset Title"
        value={title}
        onChange={e => updateImage({ title: e.target.value })}
        classes={c}
      />
      <div className={c.btnBox}>
        {
          titleColors.map(color => (
            <button
              key={color}
              type="button"
              className={`${c.button} ${color === titleColor ? c.buttonOn : c.buttonOff}`}
              onClick={() => updateImage({ titleColor: color })}
            >
              {color}
            </button>
          ))
        }
      </div>
      <div className={c.assetUrl}>
        <span className={c.infoSection}>
          {'Asset URL'}
        </span>
        <S3AssetBrowser
          value={url}
          onChange={newUrl => updateImage({ url: newUrl })}
          classes={c}
        />
      </div>
      <Row
        title="Cover Url"
        value={coverUrl}
        onChange={e => updateImage({ coverUrl: e.target.value })}
        classes={c}
      />
      <Row
        title="Social Destination URL"
        value={socialUrl}
        onChange={e => updateImage({ socialUrl: e.target.value })}
        classes={c}
      />
    </React.Fragment>
  );

  return (
    <ConfirmationModal
      message={inputField}
      actionLabel="Save"
      onClick={onClick}
      onClose={onClose}
    />
  );
};

const styles = {
  boxTitle: {
    fontSize: '23px',
    marginBottom: '5px',
  },
  infoSection: {
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '700',
    paddingTop: '10px',
  },
  btnBox: {
    display: 'flex',
    paddingTop: '10px',
  },
  button: {
    width: '72px',
    height: '35px',
    marginRight: '4px',
    borderRadius: '3px',
    border: '1px solid black',
    fontSize: '14px',
    outline: 'none',
    [DARK]: { borderColor: S.fieldLine }
  },
  // The title color choices: the chosen one is filled.
  buttonOn: { background: 'grey', color: 'white', [DARK]: { background: S.fg, color: S.onFg } },
  buttonOff: { background: 'white', color: 'black', [DARK]: { background: S.field, color: S.fg } },
  assetUrl: {
    marginTop: '10px',
    textAlign: 'left',
    fontSize: '14px',
    '&> div': {
      width: '100%'
    }
  }
};

export default injectSheet(styles)(EditAssetModal);
